<template>
  <div class="sm-plans__coupons">
    <h4>Select coupon</h4>

    <template v-if="coupons.length">
      <ul class="sm-plans__coupons-list">
        <li
          v-for="coupon in coupons"
          :key="coupon.id"
          class="sm-plans__coupons-list-item"
          :class="{
            'selected': selectedCoupon == coupon
          }"
          @click="selectedCoupon = coupon"
        >
          <radiobutton-block
            :text="coupon.code"
            :name="coupon.code"
            :checked="selectedCoupon == coupon"
          />
        </li>
      </ul>

      <btn-block
        :text="'Apply coupon'"
        :class="{
          'disabled': !selectedCoupon
        }"
        @click="$emit('select', {
          coupon_id: selectedCoupon.id,
          coupon_code: selectedCoupon.code
        })"
      />
    </template>
    <template v-else>
      <p>No available coupons.</p> 
      <p>You can create new coupons in Settings section</p>
      <btn-block
        :type="'small'"
        :text="'Ok'"
        @click="$emit('close')"
      />
    </template>
  </div>
</template>

<script>
import Radiobutton from '@/components/Radiobutton';

export default {
  name: 'billing-coupons',
  components: {
    'radiobutton-block': Radiobutton
  },
  props: {
    coupons: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedCoupon: null
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>